import { render, staticRenderFns } from "./AssetWarningView.vue?vue&type=template&id=120f8aba"
import script from "./AssetWarningView.vue?vue&type=script&lang=ts"
export * from "./AssetWarningView.vue?vue&type=script&lang=ts"
import style0 from "./AssetWarningView.vue?vue&type=style&index=0&id=120f8aba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports